import { createFileRoute } from "@tanstack/react-router";
import { requireRoutePermission } from "../../route-authorization";
import { RoutedDashboardPage } from "../../dashboard-page-context";

export const Route = createFileRoute("/app/source-reconciliation")({
  beforeLoad: () => requireRoutePermission("finance_tools.view"),
  component: RoutedDashboardPage,
});
